<template>
  <v-layout wrap>
    <v-flex xs12 md12 v-if="embedded">
      <v-currency-field xs12 md12 v-on:blur="blurred()" :label="fieldLabel" v-bind="currency_config_simple" :disabled="readonly" :decimalLength="precision" :prefix="currency" v-model="amount" box> </v-currency-field>
    </v-flex>

    <v-flex xs12 md12 style="vertical-align: top" v-else>
      <v-currency-field xs12 md12 v-on:blur="blurred()" :label="fieldLabel" v-bind="currency_config_simple" :disabled="readonly" :decimalLength="precision" :prefix="currency" v-model="amount" box> </v-currency-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Helpers from "@/helpers.js"
export default {
  props: {
    field: {
      type: Object,
    },
    data: {
      type: Number,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
    },
  },
  data() {
    return {
      items: ["GBP", "USD", "HKD", "EUR", "AUD", "ZAR"],
      itemSelection: null,
      priceDropdown: 0,
      priceSimple: 0,
      errors: {},
      prefix: "",
      currency_config_simple: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false,
        allowBlank: true,
        price: 0.0,
      },
      currency_config_dropdown: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false,
        allowBlank: true,
        price: 0.0,
      },
    }
  },
  computed: {
    fieldLabel() {
      return this.field.display_name ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    displayCurrencySelector() {
      return !!this.field.display_currency_selector
    },
    amount: {
      get() {
        if (this.data) {
          let val = this.data.toFixed(this.precision)
          const testString = `-${parseFloat(0).toFixed(this.precision).toString()}`
          if (val.toString() === testString) {
            val = 0
          }
          return val
        } else {
          return 0.0
        }
      },
      set(newAmount) {
        this.$emit("update-item", { field: this.field.name, data: newAmount, row: this.row })
      },
    },
    currency() {
      return this.field.symbol
    },
    precision() {
      return this.field.precision || 2
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) {
        readonly = this.field.readonly
      }
      return readonly
    },
  },
  methods: {
    getSymbol() {
      switch (this.itemSelection) {
        case "GBP":
          this.prefix = "£"
          break
        case "USD":
        case "HKD":
        case "AUD":
          this.prefix = "$"
          break
        case "EUR":
          this.prefix = "€"
          break
        case "ZAR":
          this.prefix = "R"
          break
        default:
          this.prefix = ""
      }
    },
    blurred() {
      this.$emit("blurred", {
        field: this.field.name,
        data: this.data,
        row: this.row,
      })
    },
  },
}
</script>
